import { Project } from 'core/models/project';
import { StreamConnector } from '../StreamConnector';
import { TokenKeeper } from '../TokenKeeper';
import { FMSWebsocketAPI } from './ws';

export interface FMSWebsocketAPIFactory {
    create(projectId: Project.Id): Promise<FMSWebsocketAPI>;
    release(api: FMSWebsocketAPI): Promise<void>;
}

export class BasicFMSWebsocketAPIFactory implements FMSWebsocketAPIFactory {
    constructor(private readonly connector: StreamConnector, private readonly tokenKeeper: TokenKeeper) {
    }

    async create(projectId: Project.Id): Promise<FMSWebsocketAPI> {
        const api = new FMSWebsocketAPI(this.connector, this.tokenKeeper);
        await api.connect(projectId);
        return api;
    }

    async release(api: FMSWebsocketAPI): Promise<void> {
        await api.disconnect();
    }
}

export class SharedFMSWebsocketAPIFactory implements FMSWebsocketAPIFactory {
    private instance?: FMSWebsocketAPI;
    private counter = 0;

    constructor(
        connector: StreamConnector,
        tokenKeeper: TokenKeeper,
        private readonly underlyingFactory = new BasicFMSWebsocketAPIFactory(connector, tokenKeeper)) {
    }

    async create(projectId: Project.Id): Promise<FMSWebsocketAPI> {
        ++this.counter;

        if (this.instance) return this.instance;

        const api = await this.underlyingFactory.create(projectId);
        this.instance = api;
        return api;
    }

    async release(api: FMSWebsocketAPI): Promise<void> {
        if (api !== this.instance) return;

        --this.counter;

        if (this.counter === 0) {
            await api.disconnect();
        }
    }
}
